<div class="sort-scope-line">
  <span class="sort-scope-status">
    {{ "GENERICS.SORTED_BY" | translate }}
    <span class="sort-scope-column">{{ columnLabelKey | translate }}</span>
  </span>
  <span class="sort-scope-separator" aria-hidden="true">·</span>
  <button type="button" class="sort-scope-action" (click)="onReset()">
    {{ "GENERICS.RESET" | translate }}
  </button>
</div>
